import { Component, inject, input, OnChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

import { AccessService } from '../../services/access.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [MatIconModule, MatButtonModule]
})
export class HeaderComponent implements OnChanges {
  private router = inject(Router);
  private accessService = inject(AccessService);
  private userService = inject(UserService);

  readonly appTitle = input<string | undefined>(undefined);
  readonly nav = input.required<string>();
  user: unknown;
  area!: string;
  actMenu!: number;
  localNav!: string;
  currentUser = this.userService.userProfile;
  showProfileInfo = false;
  roles = this.accessService.userRoleProvider;

  ngOnChanges(): void {
    this.localNav = this.nav();
  }

  switchTo(target: string, area: string) {
    this.area = area;
    this.router.navigateByUrl(target);
  }

  getClass(act: string) {
    if (act === this.localNav) {
      return 'actMenu';
    } else {
      return '';
    }
  }

  goTo(area: number) {
    this.actMenu = area;
    switch (area) {
      case 0:
        this.router.navigate(['/']);

        break;
      case 1:
        this.router.navigate(['recommendations/GPIA']);
        break;
      case 2:
        this.router.navigate(['recommendations/GPRM']);
        break;
      case 3:
        this.router.navigate(['admin']);
        break;
    }
  }

  isAdmin(): boolean {
    return this.accessService.isAdmin();
  }

  isGPRM(): boolean {
    return this.accessService.isGprmRead();
  }

  isGPIA(): boolean {
    return this.accessService.isGpiaRead();
  }
}
